export function hover_intent(el, duration = 300, hover_class = 'hover') {
    
	if (typeof el === 'string') {
		el = document.querySelector(el);
	}

	if (!el || typeof el.hover_intent !== 'undefined') return;

	el.hover_intent = null;

	el.addEventListener('pointerenter', () => {
		clearTimeout(el.hover_intent);
		el.classList.add(hover_class);
	});

	el.addEventListener('pointerleave', () => {
		clearTimeout(el.hover_intent);
		el.hover_intent = setTimeout(() => {
			el.classList.remove(hover_class);
		}, duration);
	});
}

export function dynamic_load_trigger(options){

    let triggers = null;
    let trigger = null;
    
    if ( typeof options.triggers !== 'undefined' ) {

        if( typeof options.triggers === 'string' ) {
            options.triggers = document.querySelectorAll(options.triggers);
        }

        triggers = options.triggers;
        if( !triggers.length ) return;

        triggers.forEach(el=>{
            el.addEventListener(options.event, load);
        });
    }
    else if( typeof options.trigger !== 'undefined' ) {

        if( typeof options.trigger === 'string' ) {
            options.trigger = document.querySelector(options.trigger);
        }

        trigger = options.trigger;
        if( !trigger ) return;

        trigger.addEventListener(options.event, load);
    }

    function load(){

        if( triggers ) {
            triggers.forEach(el=>{
                el.removeEventListener(options.event, load);
            });
        } else if ( trigger ) {
            trigger.removeEventListener(options.event, load);
        }

        options.load();
    }

}

export function jquery_ajax(route, payload = {}, options){
    if( !route ) return;

    let data = {
        action: 'ff_custom_ajax',
        nonce: ff.ajax_nonce,
        route,
    }

    jQuery.ajax({
        url: ff.ajax_url,
        type: "post",
        data: {...data, ...payload},
        dataType : "json",
    })
    .done(function(res){
        if( typeof options.done === 'function' ) {
            options.done(res);
        }
    })
    .always(function(res){
        if( typeof options.always === 'function' ) {
            options.always(res);
        }
    })
}

export function ajax(route, payload = {}, callback = null, type = 'json') {

    const request = fetch(`${ff.theme_url}/src/modules/ajax/main.php?route=${route}&nonce=${ff.ajax_nonce}`, {
        method: "POST",
        body: JSON.stringify(payload),
    })
    
    if( typeof callback === 'function' ) {
        request.then(res=>{
            if( type === 'json' ) {
                return res.json();
            }
            return res.text();
        }).then(res=>{
            callback(res);
        })
    }
}